import { BaseModel } from '~/shared/model'
import { isUnknownObject, isString } from '~/shared/utils/guards'
import { fillOwnProperties, formatPhone } from '~/shared/utils/helpers'

export default class AccountUser extends BaseModel {
  id: string = ''
  email: string = ''
  name: string = ''
  phone: string = ''
  birthDate: string = ''
  formattedPhone?: string = ''
  checkboxValue: boolean = false

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      if (data.phone && isString(data.phone)) {
        this.formattedPhone = formatPhone(data.phone)
      }
    }
  }
}
